import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { Timespending } from '@/app.context/workspace/Event';
import { EffortRmodel, Timeffort } from '@/app.context/workspace/persons/sunrises/effort.rmodel'
import { Direction, SegmentEnd } from '@/logic/_infra/_tech';
import { TimeSegment } from '@/logic/_infra/time';
import { emits, offset as offset_f } from '@/components/Workspaces/persons/_spec/timeline/clock_timeline'


import dayjs from 'dayjs'
import { computed } from 'vue';
import utc from 'dayjs/plugin/utc'






export default /*#__PURE__*/_defineComponent({
  __name: 'TimelineSimpleSubClocksComponent',
  props: {
    timepoint: {},
    item: {},
    timeffort: {},
    edge: {},
    offset: {}
  },
  emits: emits,
  setup(__props: any, { emit: __emit }) {


const props = __props

// const emit = defineEmits({
//     "click"(d: Direction, e: SegmentEnd, effort: EffortRmodel, timeffort: Timeffort | null, timespending: Timespending | null) {

//         return true
//     }
// })

const emit = __emit

const edge = computed(() => {

    if (props.edge == undefined) return null

    else return props.edge
})

function click(d: Direction, e: SegmentEnd, effort: EffortRmodel, timeffort: Timeffort | null, timespending: Timespending | null) {

    emit("click", d, e, effort, timeffort, timespending)
}


const offset = offset_f(props)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", null, [
    _createElementVNode("span", {
      class: "clickable",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (click('B', edge.value ?? 'S', _ctx.item, _ctx.timeffort, null)))
    }, _toDisplayString(_unref(dayjs)(_ctx.timepoint).utcOffset(_unref(offset)).format("HH:mm")), 1),
    _createElementVNode("i", {
      onClick: _cache[1] || (_cache[1] = ($event: any) => (click("F", edge.value ?? "E", _ctx.item, _ctx.timeffort, null))),
      class: "bi bi-plus-square-dotted clickable"
    })
  ]))
}
}

})